import { render, staticRenderFns } from "./human.vue?vue&type=template&id=146ff107&"
import script from "./human.vue?vue&type=script&lang=js&"
export * from "./human.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports